export default __webpack_public_path__ + "static/media/front-loader.75a2dae5.mp4";